<template>
  <vue-simplemde
    class="text-editor"
    v-bind="$attrs"
    :value="value"
    @input="onInput"
    preview-class="markdown-body"
    ref="markdownEditor"
    :configs="configs" />
</template>

<script>
import VueSimplemde from 'vue-simplemde'
// import markdownEditor from 'vue-simplemde/src/markdown-editor'
// import { EventBus } from "@/event-bus"
// TODO: Install navigation guard on hasUnsavedChanges

export default {
  inheritAttrs: false,
  props: {
    value: {}
  },
  data() {
    return {
      text: '',
      configs: {
        // See: https://github.com/sparksuite/simplemde-markdown-editor
        // autosave: true, // TODO
        spellChecker: false,
        autofocus: true,
        hideIcons: ["side-by-side", "fullscreen"], // TODO
        status: false,
        toolbar: [
          {
            name: "custom",
            action(editor) { this.callback() },
            className: "fa fa-save",
            title: "Save",
            callback: null
          },
          {
            name: "custom",
            action(editor) { this.callback() },
            className: "fa fa-times",
            title: "Cancel",
            callback: null
          },
          "|",
          "undo", "redo", "|",
          "bold", "italic", "strikethrough", "|",
          "heading", "code", "quote", "unordered-list", "|",
          "link", "image", "horizontal-rule", "|",
          "preview", "guide",
          // "heading-smaller", "heading-bigger", "heading-1", "heading-2", "heading-3",
          // "ordered-list", "clean-block", "separator-1", "separator-2", "separator-3", "table",
          // "separator-4", "separator-5", "side-by-side", "fullscreen",
        ],
      }
    }
  },
  mounted() {
    // EventBus.$on('markdownText-save', value => this.onSave());
  },
  created() {
    this.configs.toolbar[0].callback = this.onSave;
    this.configs.toolbar[1].callback = this.onCancel;
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event)
      this.text = $event;
    },
    onSave() {
      this.$emit('save', this.text)
    },
    onCancel() {
      this.$emit('cancel')
    },
  },
  components: {
    // markdownEditor,
    VueSimplemde,
  }
}
</script>

<style>
@import '~simplemde/dist/simplemde.min.css';
@import '~github-markdown-css';

.text-editor {
  line-height: 1;
}
.text-editor .CodeMirror {
  border-radius: 0 !important; /* fixes bug in chrome, where content disappears */
}
.text-editor .editor-toolbar::before,
.text-editor .editor-toolbar::after {
  margin: 0;
}
</style>
